const basePath = "/";

const Login = () =>
  import(/* webpackChunkName: "login" */ "../src/views/login.vue");

// const OrderQuery = () =>
//   import(/* webpackChunkName: "order" */ "../src/views/order/orderQuery.vue");
const Home = () =>
  import(/* webpackChunkName: "home" */ "../src/views/home.vue");
const NotFound = () =>
  import(/* webpackChunkName: "NotFound" */ "../src/views/notFound.vue");
const reset = () =>
  import(/* webpackChunkName: "reset" */ "../src/views/resetPass.vue");

const Forgot = () =>
  import(/* webpackChunkName: "forgot" */ "../src/views/forgot.vue");
export default [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "login",
    },
  },
  {
    path: "/",
    name: "login",
    component: Login,
    meta: {
      title: "login",
    },
  },
  {
    path: "/reset",
    name: "reset",
    component: reset,
    meta: {
      title: "reset",
    },
  },
  {
    path: "/forgot",
    name: "forgot",
    component: Forgot,
    meta: {
      title: "forgot",
    },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      title: "SIS Platform Management System",
      requireAuth: true,
    },
    // children: [
    // {
    //     path: 'qrder/query',
    //     name: 'qrderQuery',
    //     component: OrderQuery,
    //     meta: {
    //         title: 'qrderQuery',
    //     }
    // },

    // ]
  },
  {
    path: "*",
    name: "notFound",
    component: NotFound,
    meta: {
      title: "404",
    },
  },
];
